import { BaseLaserToolModel } from "./BaseLaserToolModel";

/** Web counterpart of Unity's `Tools/LaserTool.cs`. */
export class LaserToolModel extends BaseLaserToolModel {}

export const LASER_TOOL_MODEL = Symbol.for("Campfire.LaserToolModel");
